<template>
  <div v-if="current_product.images.length > 1">
    <ul class="image-list m-0 p-0 list-unstyled bg-light p-2">
      <li v-for="image in current_product.images" :key="image.id" class="my-1 mb-2 mx-1 mx-xl-0 p-0" @click="this.$emit('imageClicked', image.url)">
        <div class="image-container">
          <img :src="image.thumb_url" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      current_product: Object
    }
  }
</script>
